<template>
  <section id="fastest-solution" class="text-center lg:mb-24">
    <span class="inline-block uppercase text-base sm:text-lg bg-blue2 bg-opacity-25 text-primary tracking-widest font-rubik-medium text-center rounded-25 py-2 px-14 mx-2 md:mt-8 mt-5">
      {{ $t('fastestSolution') }}
    </span>
    <h3 class="font-bree-serif md:text-3xl mt-8 mb-6">
      {{ $t('threeSteps') }}
    </h3>
    <div class="flex flex-wrap lg:flex-nowrap justify-center items-center mt-20">
      <template v-for="(solution, index) in solutions">
        <div :key="index" class="w-full lg:w-1/4 lg:mb-0 md:mb-20 mb-14" :class="{'lg:mr-4': index !== 3}">
          <card-with-number :number="solution.number" :bg-color="solution.bgColor" max-height="160px">
            <div class="md:mt-14 mb-6 mt-10 md:mx-4">
              <h4 class="mb-2 text-lg">
                {{ $t(solution.title) }}
              </h4>
              <p>{{ $t(solution.desc) }}</p>
            </div>
          </card-with-number>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FastestSolution',
  data: () => ({
    solutions: [
      {
        number: '1',
        bgColor: '#F6F4FC',
        title: 'signup',
        desc: 'fastestSolution1'
      },
      {
        number: '2',
        bgColor: '#FAF2FE',
        title: 'createSchedule',
        desc: 'fastestSolution2'
      },
      {
        number: '3',
        bgColor: '#F3F3FE',
        title: 'consultation',
        desc: 'fastestSolution3'
      }
    ]
  })
}
</script>

<style scoped>

</style>
